module.exports = __webpack_public_path__ + "static/media/project_icon.63de2c0e.svg";